export class Constantes {

  public static SERVICIO_AUTENTICACION = 'autenticacion/';
  public static SERVICIO = 'historicoConductor/';
  public static SERVICIO_INTERNO = 'historicoConductorInterno/';
  public static SERVICIO_RECAPTCHA = 'recaptcha/';

  public static CODIGO_RESPUESTA_OK = 'OK';
  public static CODIGO_RESPUESTA_ERROR = 'ERROR';

  public static SECURITY_TOKEN = "security_token";

  public static CONSULTA = "C";
  public static CONSULTA_INTERNA = "CI";

  public static URL_NUEVO_PAGO = "URL_NUEVO_PAGO";
  public static FECHA_NUEVO_PAGO = "FECHA_NUEVO_PAGO";

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/QA/HistoricoConductor/frontend/src/app/shared/constantes.ts